import React from "react";

export default function Label({ item, mfg, exp, batch }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        {/* Header */}
        <div className="bg-green-700 text-white p-6">
          <h1 className="text-2xl md:text-3xl font-bold">Sun Agro Chemicals</h1>
          <p className="text-sm opacity-90">
            Thanks for Scanning Genuine Product by SUn Agro Chemicals
          </p>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-6 p-6">
          {/* Image Section */}
          <div className="flex items-center justify-center">
            <img
              src={item.imgurl}
              alt={item.Name}
              className="w-56 md:w-72 object-contain rounded-lg shadow-md"
            />
          </div>

          {/* Details Section */}
          <div className="space-y-3">
            <h2 className="text-2xl font-semibold text-green-800">
              {item.Name}
            </h2>
            <p className="text-gray-700">
              <span className="font-semibold">Technical Name:</span>{" "}
              {item.TechnicalName}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Category:</span> {item.Type}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Recommended Crops:</span>{" "}
              {item.Crops}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Packing:</span> {item.Packing}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Batch Numer:</span> {batch}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Mfg Date:</span> {mfg}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Expiry Date:</span> {exp}
            </p>
            <p className="text-gray-700">
              <span className="font-semibold">Packing:</span> {item.Packing}
            </p>

            <div className="mt-4 p-4 bg-green-50 border-l-4 border-green-600 rounded">
              <p className="text-sm text-gray-800">
                <span className="font-semibold">Usage:</span> {mfg}
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-100 p-4 text-center text-sm text-gray-600">
          © {new Date().getFullYear()} Sun Agro Chemicals •
          www.sunagrochemicals.com
        </div>
      </div>
    </div>
  );
}
